import _ from 'lodash/fp'
import {formatDate} from '@startlibs/utils'

export function dicomDateToDate(strDate) {
  if (!strDate) { return new Date(NaN) }
  const tryIso = new Date(strDate)
  if (!isNaN(tryIso.getTime())) { return tryIso}
  const ints = strDate.replace(/(\d{4})(\d\d)(\d\d)/, "$1 $2 $3").split(" ");
  return new Date(Date.UTC(
    parseInt(ints[0], 10),
    parseInt(ints[1], 10)-1,
    parseInt(ints[2], 10)
  ));
}


export const getStudyDescription = study => `${study.modality} - ${study.studyDescription} (${formatDate(dicomDateToDate(study.studyDate), 'yyyy-MM-dd')})`
export const addStudyDescription = study => _.set('fullDescription', getStudyDescription(study), study)

export const buildShareData = (authData, shareInfo) => ({
  ...authData,
  shareStudyReport: shareInfo.sharingOptions.shareStudyReport,
  allowImageDownload: shareInfo.sharingOptions.allowImageDownload,
  sharingOptions: shareInfo.sharingOptions
})

export const buildShareSession = (jwt, authData, shareInfo) => ({
  jwt,
  data: buildShareData(authData, shareInfo)
})